import React from "react";
import { Typography, Button, Row, Col, Form, message } from "antd";
import LogoImg from "../../../assets/images/smallLogo.svg";
import BannerImg from "../../../assets/images/banner.png";
import InputBox from "../../../components/common/input";
import { resetPassword } from "../../../redux/action/auth/authAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

const { Title, Text } = Typography;

const ResetPassword = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleResetPassword = (values) => {
    const { newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      message.error("Passwords do not match");
      return;
    }
    try {
      dispatch(
        resetPassword(values, () => {
          navigate("/");
          form.resetFields();
        })
      );
    } catch (error) {
      message.error("Reset Password failed. Please try again.");
    }
  };

  return (
    <div className="signinContainer">
      <Row gutter={16} className="signin-row">
        <Col xs={24} sm={12}>
          <div className="leftSection cflex">
            <div className="leftContainer">
              <img
                src={LogoImg}
                alt="Logo"
                className="logo"
                height={200}
                width={200}
              />
              <Title level={2}>Reset Password</Title>
              <Text className="subtitle mb-2">
                Almost done. Enter your new password and you’re all set.
              </Text>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleResetPassword}
                className="signin-form"
              >
                <Form.Item
                  name="newPassword"
                  label="New Password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your new password",
                    },
                    {
                      pattern:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                      message:
                        "Password must be at least 8 characters, include one uppercase, one lowercase, one number, and one special character.",
                    },
                  ]}
                >
                  <InputBox
                    size="large"
                    placeholder="New Password"
                    type="password"
                  />
                </Form.Item>

                <Form.Item
                  name="confirmPassword"
                  label="Confirm New Password"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    {
                      pattern:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                      message:
                        "Password must be at least 8 characters, include one uppercase, one lowercase, one number, and one special character.",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match!")
                        );
                      },
                    }),
                  ]}
                >
                  <InputBox
                    size="large"
                    placeholder="Confirm New Password"
                    type="password"
                  />
                </Form.Item>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="customButton mt-3"
                >
                  Reset Password
                </Button>
                <Text className="subtitle mt-5 text-center">
                  © Cultiva 2025
                </Text>
              </Form>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="rightSection cflex">
            <img src={BannerImg} alt="Banner" className="banner" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ResetPassword;
